/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc
 */

/**
 *  A single entry of {@code ApplicationResponseExtras#getAppPermissions()} — the same (id, name)
 *  pair as {@link ScopeGroupRefIF}, plus the REQUIRED/ADDITIONAL/OPTIONAL type, so this carries
 *  every field {@link ScopeGroupRefIF}/{@link ApplicationScopeGroupsIF} do.
 */

/**
 *  Application domain information containing domain and verification status.
 *  Used to encapsulate domain data for applications.
 */

/**
 *  Application listing information from the marketplace/ecosystem service.
 *  Contains metadata about an app's marketplace listing status.
 */

/**
 *  Where the app's owning portal lives, and what kind of portal it is. Raw hublet/region
 *  strings and the Hubs hub type id/name, since those vocabularies are owned elsewhere.
 */

/**
 *  Application project information containing project ID and name.
 *  Used to encapsulate project association data for applications.
 */

/**
 *  This immutable combines ApplicationCore with additional fields stored
 *  in the Applications tablespace, such as scope groups.
 */

/**
 *  Request for getting applications by portalId with optional filtering.
 */

/**
 *  Response containing applications filtered by origin.
 */

/**
 *  App-auth request for looking up an app <em>owned by the calling portal</em>, by its developer
 *  coordinates. Unlike {@link ApplicationByComponentKeyRequestIF}, this request deliberately omits
 *  the portal id: the APP gateway derives the authenticated portal from the ChirpContext, so the
 *  lookup is inherently scoped to apps the caller owns and callers only supply the project name and
 *  developer symbol (plus an optional revision id).
 */

export const getAppComponentIndexByAppIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getAppComponentIndexByAppId',
  auth: 'app',
  fingerprint: 'zfOlZmbh4S4jB_guqaBV756EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApplicationsForPortalRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getApplicationsForPortal',
  auth: 'app',
  fingerprint: 'thFeD6ZoNWvdxPdXw23J8p6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApplicationsByProjectAndPortalRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getApplicationsByProjectAndPortal',
  auth: 'app',
  fingerprint: '7D9fzzy5B7n5egHcRdC-65wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByClientIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getByClientId',
  auth: 'app',
  fingerprint: 'oYFlgwNwQlv43Etx-LLB7p6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'eppiLZXsBaf43Etx-LLB7p6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppByComponentKeyRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getAppByComponentKey',
  auth: 'app',
  fingerprint: '4SGKiCxxAQn43Etx-LLB7p6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getByIds',
  auth: 'app',
  fingerprint: 'o6rlVzmA-teq8XZMLlMqK56EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiConnectorCatalogRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getAiConnectorCatalog',
  auth: 'app',
  fingerprint: '_yHDXGksR777phBdz2eH5Z6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLocalisedAppPermissionsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getLocalisedAppPermissions',
  auth: 'app',
  fingerprint: 'vqizbSwz5lBlPrKLuON8w56EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};